import React from "react";
import { Input, PasswordInput } from "../../../../components/Input.js/Input";
import { Controller } from "react-hook-form";
import Dropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import ToggleableButton from "../../../../components/toggleableButton/toggleableButton";
import ReactTooltip from "react-tooltip";

export const UserInfo = ({
  register,
  control,
  roles,
  canChange2FA,
  canChangeRole,
  canChangeUserEmail,
  disableRole,
  selectedRole
}) => {
  return (
    <div className="users__info">
      <div className="users__section">
        <Input label="First Name" htmlFor="first_name" customProps={register("first_name")} />
        <Input label="Last Name" htmlFor="last_name" customProps={register("last_name")} />
        <Input
          label="Email"
          htmlFor="email"
          customProps={register("email", { disabled: !canChangeUserEmail })}
        />
      </div>

      <div className="users__section">
        <PasswordInput label="Password" customProps={register("password")} htmlFor="password" />
        <PasswordInput
          label="Password Confirmation"
          customProps={register("password_confirmation")}
          htmlFor="password_confirmation"
        />

        {canChangeRole && (
          <div className="users__dropdown">
            <p>Role</p>
            {disableRole ? (
              <>
                <Input
                  value={selectedRole ? selectedRole.name : "None selected"}
                  customProps={{
                    disabled: true,
                    "data-for": "disabledRoleTooltip",
                    "data-tip": "Multi-Organization User - Role cannot be edited"
                  }}
                />
                <ReactTooltip id="disabledRoleTooltip" effect="solid" place="bottom" />
              </>
            ) : (
              <Controller
                control={control}
                name="role_id"
                render={({ field: { onChange, value } }) => {
                  return (
                    <Dropdown
                      height={275}
                      haveOnSelectChange
                      options={roles}
                      selectedFilters={value}
                      numberDisplayed={0}
                      onSelectChange={(data) => onChange(data)}
                    />
                  );
                }}
              />
            )}
          </div>
        )}
      </div>
      <div className="users__section">
        <Input
          label="Phone number"
          htmlFor="phone_number"
          placeholder="+1 (999) 999 9999"
          customProps={register("phone_number")}
        />

        {canChange2FA && (
          <>
            <div className="switch">
              <p className="switch__title">Enabled 2fa</p>
              <Controller
                control={control}
                name="enabled_2fa"
                render={({ field: { onChange, value } }) => {
                  return (
                    <div className={`switch__content ${value ? "switch__content--active" : ""}`}>
                      <ToggleableButton
                        isRadio
                        title="enabled_2fa"
                        isActive={value}
                        onClick={(isActive) => onChange(isActive)}
                      />
                    </div>
                  );
                }}
              />
            </div>

            <div className="switch">
              <p className="switch__title">Hide 2fa by email link</p>
              <Controller
                control={control}
                name="disabled_2fa_by_email"
                render={({ field: { onChange, value } }) => {
                  return (
                    <div className={`switch__content ${value ? "switch__content--active" : ""}`}>
                      <ToggleableButton
                        isRadio
                        title="disabled_2fa_by_email"
                        isActive={value}
                        onClick={(isActive) => onChange(isActive)}
                      />
                    </div>
                  );
                }}
              />
            </div>

            <div className="users__dropdown">
              <p>Days interval 2fa</p>
              <Controller
                control={control}
                name="days_interval_2fa"
                render={({ field: { onChange, value } }) => {
                  return (
                    <Dropdown
                      height={275}
                      haveOnSelectChange
                      options={[1, 7, 14, 21]}
                      selectedFilters={value}
                      onSelectChange={(data) => onChange(data)}
                    />
                  );
                }}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};
